import React from 'react';

export default function AllGroups({ children }) {
  return (
    <div
      className={
        'flex flex-col lg:flex-row justify-start items-center flex-wrap'
      }
    >
      {children}
    </div>
  );
}
